
export const  titleContainer= {
    width:'100%',
    margin: 0,
    paddingBottom: 15,
    display:'flex',
    justifyContent:'space-between'  
  }
 
  export const titleText= {
    color:'#00205B', 
    Font:'Deutsche Bank Text',
    fontSize: '16px'
   }

